"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettings = exports.SettingsContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var defaultSettings_1 = __importStar(require("../config/defaultSettings"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
exports.SettingsContext = (0, react_1.createContext)([defaultSettings_1.default, function () { }]);
var useSettings = function () { return (0, react_1.useContext)(exports.SettingsContext); };
exports.useSettings = useSettings;
function Settings(_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(defaultSettings_1.default), settings = _b[0], _setSettings = _b[1];
    // const { firebaseUser } = useContext(UserContext)
    var _c = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }), status = _c.status, user = _c.user, error = _c.error, currentUser = _c.currentUser;
    var setSettings = function (setting) {
        _setSettings(__assign(__assign({}, setting), { direction: (0, defaultSettings_1.getDirFromLocale)(setting.locale) }));
    };
    (0, react_1.useEffect)(function () {
        if (!user) {
            return;
        }
        // firestore
        //     .collection('userSettings')
        //     .doc(user.uid)
        //     .get()
        //     .then(doc => {
        //         if (!doc.exists) {
        //             return
        //         }
        //         const data = doc.data()
        //         if (!data) {
        //             return
        //         }
        //         const savedSettings = removeUndefined(mapValues(defaultSettings, (_, key) => doc.get(key)))
        //         const newSettings = { ...defaultSettings, ...savedSettings }
        //     })
        setSettings(defaultSettings_1.default);
    }, [user]);
    var saveSettings = (0, react_1.useCallback)(function (newSettings) {
        if (!user) {
            return;
        }
        // firestore
        //     .collection('userSettings')
        //     .doc(firebaseUser.uid)
        //     .set(removeUndefined({ ...settings, ...newSettings }), {
        //         merge: true,
        //     })
    }, [user, settings]);
    var updateSettings = (0, react_1.useCallback)(function (newSettings) {
        var finalSettings = __assign(__assign({}, settings), newSettings);
        setSettings(finalSettings);
        saveSettings(finalSettings);
    }, [saveSettings, settings]);
    return (0, jsx_runtime_1.jsx)(exports.SettingsContext.Provider, __assign({ value: [__assign({}, settings), updateSettings] }, { children: children }));
}
exports.default = Settings;
